<template>
  <div
    :class="{
      'p-10 md:p-5 xl:p-8': position < 3,
      'md:grid md:grid-cols-2 md:space-x-4 md:p-0 col-span-2': position === 2,
      'bg-white md:bg-indigo-200 md:grid md:grid-cols-1 col-span-1 row-span-2':
        position === 3,
    }"
    class="bg-white border-1 rounded-xl shadow-md h-full"
  >
    <div
      v-if="position > 1"
      :class="{
        'md:self-center md:py-0 xl:py-10': position === 3,
      }"
      class="relative hidden md:flex flex-col items-center"
    >
      <illustration
        name="help"
        class="hidden md:block absolute bottom-2 md:bottom-2 xl:bottom-2 md:transform md:scale-60 lg:scale-70 xl:scale-80 xxl:scale-90 2xl:scale-x-100"
        height="90%"
      />
    </div>

    <div
      :class="{
        'md:col-span-1 pr-5 w-full h-full': position < 3,
        'bg-white col-span-full md:p-5 md:rounded-xl md:shadow-lg md:m-2':
          position === 3,
      }"
      class="md:self-center flex flex-col space-y-4"
    >
      <div
        class="text-2xl md:text-xl xl:text-2xl font-normal w-full text-center md:text-left"
      >
        Aide
      </div>
      <div
        class="overflow-y-auto hide-scroll-bar text-base flex flex-col space-y-5 justify-center"
        :class="{
          'h-full': position < 3,
          'h-60 md:h-56 xl:h-64': position === 3,
        }"
      >
        <div v-if="$subscribed()">
          <p>
            Pour obtenir de l’aide, vous pouvez nous contacter par téléphone :
          </p>
          <p class="text-pink-600">
            06 33 01 76 16
          </p>
        </div>

        <p v-if="$subscribed()">
          Ou via le formulaire de contact
        </p>
        <p v-else>
          Pour obtenir de l’aide, vous pouvez nous contacter via le formulaire
          de contact
        </p>
        <div class="flex justify-center w-full">
          <router-link :to="{ name: 'HelpContact' }">
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="Formulaire de contact"
              :uppercase="true"
              icon="plane"
              :right="true"
              :responsive="false"
              type-shadow="shadow-pink"
              :enable-action="false"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from './../ActionButton';
import Illustration from './../Illustration';
import Icon from './../Icon';
import { mapGetters } from 'vuex';

export default {
  props: {
    position: {
      type: Number,
      required: false,
      default: 2,
    },
  },

  components: {
    ActionButton,
    Illustration,
    Icon,
  },

  computed: {
    ...mapGetters({
      //user: "auth/user";
    }),
  },
};
</script>
